import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/closed-captioning': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 64c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h416zM458 400c3.3 0 6-2.7 6-6v-276c0-3.3-2.7-6-6-6h-404c-3.3 0-6 2.7-6 6v276c0 3.3 2.7 6 6 6h404zM246.9 314.3c1.7 2.4 1.5 5.6-0.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2 0.9zM437.3 314.3c1.7 2.4 1.5 5.6-0.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2 0.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/closed-captioning.js
// module id = 1714
// module chunks = 0